import { render, staticRenderFns } from "./NorskOrdbankResultHeader.vue?vue&type=template&id=15189e42&"
import script from "./NorskOrdbankResultHeader.vue?vue&type=script&lang=js&"
export * from "./NorskOrdbankResultHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports